import { createSlice } from "@reduxjs/toolkit";
import { fetchImages } from "../actions/imagesActions";

const initialState = {
  images: [],
  loading: false,
  error: null,
};

const imagesSlice = createSlice({
  name: "dashs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchImages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchImages.fulfilled, (state, action) => {
        state.loading = false;
        state.images = action.payload.data ?? action.payload; 
      })
      .addCase(fetchImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default imagesSlice.reducer;
